import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_svgicon = _resolveComponent("vue-svgicon")!

  return (_openBlock(), _createBlock(_component_vue_svgicon, _mergeProps({
    class: "c-icon-icon c-icon-fill",
    data: require(`@/assets/icons/${_ctx.name}.svg`)
  }, _ctx.$attrs), null, 16, ["data"]))
}